import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useGlobalState } from '../state';
import Select from "./ds/Select";
import Icon from "./ds/Icon";
import Button from "./ds/Button";
import Checkbox from "./ds/Checkbox";
import { mediaService, tagService } from '../container';

// This function compare relations object with existing relations to generate
// an object with { added: [], removed: [] } tags
function compareExistingTagsWithRelations(relatedTags, relations) {
  const existingRelations = relatedTags.reduce((relations, tag) => ({
    ...relations,
    [tag.id]: true,
  }), {});

  const added = Object
    .entries(relations)
    .filter(([tagId, checked]) => checked && !existingRelations[tagId])
    .map(([tagId, _]) => tagId);
  const removed = Object
    .entries(relations)
    .filter(([tagId, checked]) => !checked && existingRelations[tagId])
    .map(([tagId, _]) => tagId);

  return {
    added,
    removed,
  };
}

export default function TagRelations({
  tag,
}) {
  const { media: selectedMedia } = useGlobalState();
  const [loading, setLoading] = useState(false);
  const [relatedTags, setRelatedTags] = useState();
  const [medias, setMedias] = useState();
  const [selectedMediaId, setSelectedMediaId] = useState();
  const [mediaTags, setMediaTags] = useState();
  const [relations, setRelations] = useState({});

  const loadMedias = async () => {
    try {
      let medias = await mediaService.search({
        state: 'active',
      });

      medias = medias.filter((media) => media.id !== selectedMedia.id);

      setMedias(medias);
    } catch (err) {
      toast.error('Ocurrió un error al cargar los medios.');
      console.error(err);
    }
  };

  const loadRelatedTags = async () => {
    try {
      const relatedTags = await tagService.getRelations(tag.id);

      setRelatedTags(relatedTags);
      setRelations(relatedTags.reduce((relations, tag) => ({
        ...relations,
        [tag.id]: true,
      }), {}));
    } catch (err) {
      toast.error('Ocurrió un error al cargar los relaciones del tag.');
      console.error(err);
    }
  };

  const selectMediaId = async (mediaId) => {
    setSelectedMediaId(mediaId);
    setMediaTags();

    try {
      let tags = await tagService.search({
        media_id: mediaId,
      });

      setMediaTags(tags.sort((a, b) => {
        const aChecked = relations[a.id] || false;
        const bChecked = relations[b.id] || false;

        return aChecked && !bChecked ? -1 : 1;
      }));
    } catch (err) {
      toast.error('Ocurrió un error al cargar los tags del medio.');
      console.error(err);
    }
  };

  const checkTag = (tagId, checked) => {
    setRelations((relations) => ({
      ...relations,
      [tagId]: checked,
    }));
  };

  const relateTags = async () => {
    setLoading(true);

    const { added, removed } = compareExistingTagsWithRelations(relatedTags, relations);

    try {
      for (const tagId of added) {
        await tagService.relate(tag.id, tagId);
      }

      for (const tagId of removed) {
        await tagService.removeRelation(tag.id, tagId);
      }

      await loadRelatedTags();
    } catch (err) {
      toast.error('Ocurrió un error al actualizar las relaciones.');
      console.error(err);
    }

    setLoading(false);
  };

  useEffect(() => {
    loadMedias();
    loadRelatedTags();
  }, [tag.id]);

  return (
    <>
      <div id="edit-tag">
        <div className="recommended">
          <h3 className="t-heading-s">Artículos recomendados</h3>

          <p className="t-body-s">
          <Icon icon="info" />
            Cuando un artículo tenga esta etiqueta, se mostrarán artículos recomendados del medio que selecciones.
          </p>

          <Select
            placeholder="Medio"
            value={selectedMediaId}
            onChange={(e) => {
              selectMediaId(e.target.value);
            }}
          >
            {medias && medias.map((media) => (
              <option key={media.id} value={media.id}>
                {media.name} ({relatedTags?.filter((relation) => relation.media_id === media.id)?.length || 0})
              </option>
            ))}
          </Select>

          {selectedMediaId && (
            <ul className="tags">
              {mediaTags && mediaTags.map((tag, index) => (
                <li className="t-body-m" key={index}>
                  <Checkbox
                    checked={relations[tag.id] || false}
                    onchange={(e) => {
                      checkTag(tag.id, e.target.checked);
                    }}
                  />
                  {tag.title}
                </li>
              ))}
            </ul>
          )}

          <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              label="Actualizar"
              loading={loading}
              onclick={relateTags}
            />
          </div>
        </div>
      </div>

    </>
  )
}
